import { formatMoney } from '@shopify/theme-currency';

import { QuantitySelector } from './quantity_selector';
import { Emitter } from './emitter';

const CHANGE_AGGREGATION_TIME_MSEC = 500,
    UPDATING_CLASS = 'updating',
    DELETED_CLASS = 'deleted',
    BASE_URL_IMAGE = ABV4_SETTINGS.base_url_image,
    IMAGE_VERSION = ABV4_SETTINGS.images_version;

class BundleLineItem extends Emitter {
    constructor(row) {
        super();

        this.row = row;
        this.key = row.data('bundle-id');
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        const containers = row.find('.v4-quantity-selector'), selectors = [];
        for (let i = 0; i < containers.length; i++) {
            const qtyChanger = new QuantitySelector(jQuery(containers[i]));
            qtyChanger.on('change', this.handleQuantityChange);
            selectors.push(qtyChanger);
        }
        this.qtySelectors = selectors;
    }

    handleQuantityChange(e, newQty) {
        let newQuantity = newQty;
        for (const selector of this.qtySelectors) {
            let jQselector = jQuery(selector);
            const bundleProductQty = selector.input.attr('data-bundle-base-qty');
            if (bundleProductQty) {
                const qty = parseInt(bundleProductQty);
                newQuantity = newQty * qty;
            }
            selector.setValue(newQuantity);
        }
        this.emit('bundlequantitychange', newQty);
    }
}

class LineItem extends Emitter {
    constructor(row) {
        super();
        this.row = row;
        this.key = row.data('item-key');
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        const containers = row.find('.v4-quantity-selector'), selectors = [];
        for (let i = 0; i < containers.length; ++i) {
            const handle = $(containers[i]).attr('data-product-handle')
            const qs = new QuantitySelector(jQuery(containers[i]));
            qs.setProductCartQuantity(handle);
            qs.on('change', this.handleQuantityChange);
            selectors.push(qs);
        }

        this.quantitySelectors = selectors;

        this.pricingBlocks = row.find('.pricing-block');
    }

    quantity() {
        const [selector] = this.quantitySelectors;
        return selector != null ? selector.value() : null;
    }

    markForUpdate() {
        this.row.addClass(UPDATING_CLASS);
    }

    clearUpdateMark() {
        this.row.removeClass(UPDATING_CLASS);
    }

    handleQuantityChange(e, newQuantity) {
        for (const selector of this.quantitySelectors) {
            selector.setValue(newQuantity);
        }
        this.emit('quantitychange', newQuantity);
    }

    updatePricingBlock(block, itemData) {
        const
            { quantity } = itemData,
            comparisonBasisPrice = block.data('comparison-basis-price'),
            linePrice = itemData.line_price,
            comparisonLinePrice = comparisonBasisPrice * quantity,
            priceString = linePrice ? formatMoney(linePrice, window.moneyFormat) : 'FREE!';
        block.find('.item-total').text(priceString);
        if (comparisonLinePrice)
            block.find('.item-comparison-total').text(formatMoney(comparisonLinePrice, window.moneyFormat));
    }

    update(itemData) {
        const { quantitySelectors, pricingBlocks } = this,
            newQuantity = itemData !== null ? parseInt(itemData.quantity, 10) : 0;
        this.row.toggleClass(DELETED_CLASS, !itemData);

        for (const qs of quantitySelectors)
            qs.setValue(newQuantity);

        if (itemData !== null) {
            for (let i = 0; i < pricingBlocks.length; ++i)
                this.updatePricingBlock(pricingBlocks.eq(i), itemData);
        }
    }
}

export class CartForm {
    constructor(cart, form, api) {
        this.cart = cart;
        this.form = form;
        this.api = api;
        this.updateTimerId = null;
        this.updateCounter = 0;
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.handleCartChange = this.handleCartChange.bind(this);
        this.handleRemoveBundle = this.handleRemoveBundle.bind(this);
        this.update = this.update.bind(this);
        this.handleBundleQuantityChange = this.handleBundleQuantityChange.bind(this);
        this.bundleTrigger = false;
        this.loadCart();
        const lineItems = {},
            itemRows = form.find('div.line-item'),
            itemBundleRows = form.find('div.bundle-line-item-wrapper');
        for (let i = 0; i < itemRows.length; ++i) {
            const row = jQuery(itemRows[i]),
                lineItem = new LineItem(row);
            lineItem.on('quantitychange', this.handleQuantityChange);
            lineItems[lineItem.key] = lineItem;

        }
        for (let i = 0; i < itemBundleRows.length; ++i) {
            const bundleRow = jQuery(itemBundleRows[i]),
                bundleLineItem = new BundleLineItem(bundleRow),
                removeBundle = bundleRow.find('.remove-kit-link');
            removeBundle.on('click', this.handleRemoveBundle);
            bundleLineItem.on('bundlequantitychange', this.handleBundleQuantityChange);

        }
        this.lineItems = lineItems;
        this.cart.on('cartchange', this.handleCartChange);
    }

    getProductCartQuantity(productHandle) {
        const cartUniqueQuantity = ABV4_SETTINGS.cart_quantity.unique_cart_quantity.unique_quantity;
        const regularQunatityCondition = ABV4_SETTINGS.cart_quantity.cart_quantity_single_max;
        const cartUniqueQuantityConditions = ABV4_SETTINGS.cart_quantity.unique_cart_quantity.conditions_variant;
        let unique = false;
        for(let i = 0; i < cartUniqueQuantityConditions.length; i++) {
            const item = cartUniqueQuantityConditions[i];

            if(productHandle == item) {
                unique = true;
            }
        }

        if(unique) {
            return cartUniqueQuantity;
        } else {
           return regularQunatityCondition;
        }
    }

    loadCart() {
        let lineProductItem = '';
        let bundleInUse = '';
        let bundlePrice = 0;
        let compareAtPriceBundle = 0;
        let totalBundlePrice = [];
        let bundleClass = '';
        let freeProductIsActive = false;
        const cartItemCount = shoppingCart.length;
        const { free_products } = ABV4_SETTINGS.free_gift;
        shoppingCart.map((lineItem, index) => {
            let compareAtPrice = '';
            const {
                key,
                featured_image,
                product_id,
                variant_id,
                handle,
                url,
                title,
                line_price,
                final_line_price,
                original_price,
                quantity,
                compare_at_price,
                product_type,
                properties,
                selling_plan,
                selling_plan_compare_at_price,
                discounted_price
            } = lineItem;
            if (compare_at_price) {
                compareAtPrice = '<del class="item-comparison-total2">' + formatMoney(parseFloat(compare_at_price) * quantity, window.moneyFormat) + '</del>';
            } else if (properties._single_product && (lineItem.original_price > lineItem.final_price)) {
                compareAtPrice = '<del class="item-comparison-total2">' + formatMoney(parseFloat(original_price) * quantity, window.moneyFormat) + '</del>';
            } else if (selling_plan_compare_at_price) {
                compareAtPrice = '<del class="item-comparison-total2">' + formatMoney(parseFloat(selling_plan_compare_at_price) * quantity, window.moneyFormat) + '</del>';
            } else {
                compareAtPrice = '';
            }

            const singleProductCartQuantityMax = this.getProductCartQuantity(handle);
            let finalLinePrice = final_line_price == 0 ? "<span>FREE</span>" : formatMoney(final_line_price, window.moneyFormat);
            if (properties._free_gift !== "true") {
                if (properties.hasOwnProperty('_bundle') && !properties._single_product) {
                    const {
                        _bundle,
                        _bundle_discount,
                        _base_product_qty,
                        _bundle_class,
                        _single_product,
                        _free_bundle_component,
                        _frequency
                    } = properties,
                        bundleItemOriginalPrice = compare_at_price !== '' ? compare_at_price : original_price,
                        compareAtPriceFormated = formatMoney(parseFloat(bundleItemOriginalPrice) * quantity, window.moneyFormat);

                    compareAtPrice = bundleItemOriginalPrice;
                    if (bundleClass !== _bundle_class) {
                        bundlePrice = 0;
                        compareAtPriceBundle = 0
                    }
                    bundleClass = _bundle_class;
                    if (_bundle !== bundleInUse && bundleInUse !== '') {
                        lineProductItem += `</div>`;
                    }
                    
                    if (_bundle !== bundleInUse || bundleInUse === "") {
                        let bundleQty = 1;
                        bundleInUse = _bundle;
                        const freq = _frequency !== undefined ? _frequency : '',
                            freqHideQtyChanger = _frequency !== '' ? 'd-none' : '',
                            baseProductQty = parseFloat(_base_product_qty),
                            bundleName = _bundle.split(' * ');
                        if (baseProductQty === 1) {
                            bundleQty = quantity;
                        } else {
                            if (baseProductQty >= quantity) {
                                bundleQty = baseProductQty / quantity;
                            } else {
                                bundleQty = quantity / baseProductQty;
                            }
                        }
                        let bundleImageClass = bundleClass;
                        if (_frequency !== '') {
                            bundleImageClass = bundleClass.split('_*_')[0];
                        }

                        let bundleImage = `<img
                                        class="lazyload"
                                        alt="` + featured_image.alt + `"
                                        data-expand="-20"
                                        data-src="` + BASE_URL_IMAGE + `cart_bundle_` + bundleImageClass + `_{width}x.jpg?v=` + IMAGE_VERSION + `"
                                        data-master-src="` + BASE_URL_IMAGE + `cart_bundle_` + bundleImageClass + `.jpg?v=` + IMAGE_VERSION + `"
                                        data-master-width="500"
                                        data-master-height="500"
                                        data-aspectratio="1.0"
                                        data-sizes="auto"
                                    >`;
                        if (properties.hasOwnProperty('_black_friday') && properties._black_friday == true) {
                            bundleImage = `<img
                                    width="100%"
                                    class="lazyload"
                                    alt="` + featured_image.alt + `"
                                    data-expand="-20"
                                    data-src="` + featured_image.data_src + `"
                                    data-master-src="` + featured_image.url + `"
                                    data-master-width="` + featured_image.width + `"
                                    data-master-height="` + featured_image.height + `"
                                    data-aspectratio="` + featured_image.aspect_ratio + `"
                                    data-sizes="auto"
                                >`;
                        }
                        const disabledBundleQtyUp = bundleQty >= ABV4_SETTINGS.cart_quantity_bundle_max ? 'disabled' : '';
                        lineProductItem += `<div class="bundle-line-item-wrapper" data-bundle-id="` + bundleClass + `">
                            <div class="bundle-header">
                               <div class="item">
                                <div class="item-body">
                                  <div class="image-frame">
                                    ${bundleImage}
                                    </div>
                                    <div class="item-details justify-content-end">
                                        <h4 class="item-title bundle-heading">` + bundleName[0] + `</h4>
                                        <h6 class="frequency">` + freq + `</h6>
                                        <p class="mt-4">CONTAINS:</p>
                                    </div>
                                </div>
                                </div>
                            <div class="quantity">
                                <div class="v4-quantity-selector mt-3 ${freqHideQtyChanger}">
                                    <button type="button" class="step-button-kit down">-</button>
                                    <input type="number" value="` + bundleQty + `" min="1" max="${ABV4_SETTINGS.cart_quantity_bundle_max}" disabled>
                                    <button type="button" class="step-button-kit up" ${disabledBundleQtyUp}>+</button>
                                </div>
                                <a class="remove-kit-link" data-bundle-class-id="` + bundleClass + `" href="#">Remove</a>
                            </div>
                            <div class="total bundle-price-total-wrapper" data-bundle-class-id="` + bundleClass + `">
                                    <del class="compare-at_price_bundle"></del>
                                    <span class="bundle-price"></span>
                                </div>
                            </div><div class="contains-line"><p class="bundle-heading">Contains:</p></div>`;
                    }
                    bundlePrice += parseFloat(final_line_price);
                    if (!_free_bundle_component) {
                        compareAtPriceBundle += parseFloat(compareAtPrice) * quantity;
                    } else {
                        compareAtPriceBundle += 0;
                    }
                    totalBundlePrice[bundleClass] = {
                        'compare_at_price': compareAtPriceBundle,
                        "bundle_price": bundlePrice
                    };
                    let preparedTitle = title;
                    if (fake_product_name[handle]) {
                        preparedTitle = fake_product_name[handle];
                    }
                    let hasSubClass = '';
                    let subDelivery = '';
                    if(selling_plan !== null) {
                        hasSubClass = "line-item-subscription";
                        subDelivery = `<span class="line-item-subscription-frequency">(${selling_plan.name})</span>`;
                    }
                    let freeBundleHtml = '';
                    if (_free_bundle_component)
                        freeBundleHtml = `<span class="bundle_free_verbiage">FREE</span>`;
                    lineProductItem += `<div class="line-item ${hasSubClass}" data-item-key="` + key + `">
                    <div class="quantity">
                        <div class="quantity-block">
                        <div class="line-item-quantity">` + quantity + `</div>
                            <div class="v4-quantity-selector  d-none">
                                <button type="button" class="step-button down">-</button>
                                <input type="number" data-bundle-base-qty="` + _base_product_qty + `" value="` + quantity + `" min="1" max="` + _base_product_qty * ABV4_SETTINGS.cart_quantity_bundle_max + `">
                                    <button type="button" class="step-button up">+</button>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-body">
                            <div class="item-details">
                                <h4 class="item-title">
                                    ${freeBundleHtml}
                                    ` + preparedTitle + `
                                    ${subDelivery}
                                </h4>
                                <input type="hidden" name="product_id[` + index + `]" value="` + product_id + `">
                                <input type="hidden" name="variant_id[` + index + `]" value="` + variant_id + `">
                                <input type="hidden" name="quantity[` + index + `]" value="` + quantity + `">
                            </div>
                        </div>
                    </div>
                    <div class="total">
                        <div class="pricing-block" data-basis-price="` + line_price + `" data-comparison-basis-price=` + compareAtPrice + `>
                            <del class="item-comparison-total2">` + compareAtPriceFormated + `</del>
                            <span class="item-total2" data-total-price="` + final_line_price + `"
                                  data-original-price="` + original_price + `">` + finalLinePrice + `</span>
                        </div>
                    </div>
                </div>`;
                } else {
                    if (bundleInUse !== '' && properties._single_product) {
                        lineProductItem += '</div>';
                    }
                    let lineItemCompareAt = '';
                    if (bundleInUse !== '') {
                        lineProductItem += `</div>`;
                    }
                    if (properties._single_product) {
                        lineItemCompareAt = original_price;
                    } else if (selling_plan_compare_at_price) {
                        lineItemCompareAt = selling_plan_compare_at_price;
                    } else {
                        lineItemCompareAt = compare_at_price;
                    }
                    const sellingPlan = selling_plan ? selling_plan.name : '';
                    const disabledSingleProductQtyUp = quantity >= singleProductCartQuantityMax ? 'disabled' : '';
                    const doubledProduct = doubled_products[handle] ? `data-handle="${handle}"` : '';
                    let disabledDoubledProduct = '';
                    if (doubled_products[handle]) {
                        if (quantity == doubled_products[handle] + 1)
                            disabledDoubledProduct = 'disabled';
                    }
                    lineProductItem += `<div class="line-item-wrapper"><div class="line-item" data-item-key="` + key + `">
                    <div class="item">
                        <div class="item-body">
                            <div class="image-frame">
                                <img
                                    width="100%"
                                    class="lazyload"
                                    alt="` + featured_image.alt + `"
                                    data-expand="-20"
                                    data-src="` + featured_image.data_src + `"
                                    data-master-src="` + featured_image.url + `"
                                    data-master-width="` + featured_image.width + `"
                                    data-master-height="` + featured_image.height + `"
                                    data-aspectratio="` + featured_image.aspect_ratio + `"
                                    data-sizes="auto"
                                >
                            </div>
                            <div class="item-details">
                                <h6 class="collections">` + product_type + `</h6>
                                <h4 class="item-title">
                                    <a href="` + url + `">` + title + `</a>
                                </h4>
                                <h6 class="collections">${sellingPlan}</h6>
                                <input type="hidden" name="product_id[` + index + `]" value="` + product_id + `">
                                <input type="hidden" name="variant_id[` + index + `]" value="` + variant_id + `">
                                <input type="hidden" name="quantity[` + index + `]" value="` + quantity + `">
                            </div>
                        </div>
                    </div>
                    <div class="quantity">
                        <div class="quantity-block" >
                            <div class="v4-quantity-selector" ${doubledProduct} data-product-handle="${handle}">
                                <button type="button" class="step-button down" ${disabledDoubledProduct}>-</button>
                                <input type="number" value="` + quantity + `" min="1" max="${singleProductCartQuantityMax}" disabled>
                                <button type="button" class="step-button up" ${disabledSingleProductQtyUp}>+</button>
                            </div>
                            <a class="remove-link"
                               href="/cart/change?id=` + key + `&amp;quantity=0">Remove</a>
                        </div>
                    </div>
                    <div class="total">
                        <div class="pricing-block" data-basis-price="` + line_price + `" data-comparison-basis-price=` + lineItemCompareAt + `>
                            ` + compareAtPrice + `
                            <span class="item-total2" data-total-price="` + final_line_price + `"
                                  data-original-price="` + original_price + `">` + formatMoney(final_line_price, window.moneyFormat) + `</span>
                        </div>
                    </div>
                </div></div>`;
                }
            } else {
                if (free_products) {
                    freeProductIsActive = true;
                    lineProductItem += `<div class="free-gift line-item-wrapper"><div class="line-item-free-gift line-item" data-item-key="` + key + `">
                    <div class="item">
                        <div class="item-body">
                            <div class="image-frame">
                                <img
                                    width="100%"
                                    class="lazyload"
                                    alt="` + featured_image.alt + `"
                                    data-expand="-20"
                                    data-src="` + featured_image.data_src + `"
                                    data-master-src="` + featured_image.url + `"
                                    data-master-width="` + featured_image.width + `"
                                    data-master-height="` + featured_image.height + `"
                                    data-aspectratio="` + featured_image.aspect_ratio + `"
                                    data-sizes="auto"
                                >
                            </div>
                            <div class="item-details">
                                <h6 class="collections">` + product_type + `</h6>
                                <h4 class="item-title">
                                    <a href="` + url + `">` + title + `</a>
                                </h4>
                                <input type="hidden" name="product_id[` + index + `]" value="` + product_id + `">
                                <input type="hidden" name="variant_id[` + index + `]" value="` + variant_id + `">
                                <input type="hidden" name="quantity[` + index + `]" value="` + quantity + `">
                            </div>
                        </div>
                    </div>
                    <div class="quantity">
                        <div class="quantity-block">
                            <div class="v4-quantity-selector">
                                <div class="qty">` + quantity + `</div>
                            </div>
                        </div>
                    </div>
                    <div class="total">
                        <div class="pricing-block" data-basis-price="` + line_price + `" data-comparison-basis-price=` + compare_at_price + `>
                            ` + compareAtPrice + `
                            <span class="item-total2" data-total-price="` + final_line_price + `"
                                  data-original-price="` + original_price + `">` + finalLinePrice + `</span>
                        </div>
                    </div>
                </div></div>`;
                }
            }
        });


        if (!freeProductIsActive && free_products) {
            const freeProductHolder = this.freeProductHolder();
        }

        $('.line-items-wrapper').append(lineProductItem);
        if (!freeProductIsActive && free_products) {
            const freeProductHolder = this.freeProductHolder();
            $('.line-items-wrapper').append(freeProductHolder);
        }

        const totalBundlesPrice = $('.bundle-price-total-wrapper');
        this.getTotalBundlesPrice(totalBundlesPrice, totalBundlePrice);
        $('.line-items-wrapper').removeClass('loading');

    }


    freeProductHolder() {
        return `<div class="free-gift line-item-wrapper d-none">
                    <div class="line-item-free-gift" data-item-key="">
                        <div class="item">
                            <div class="item-body">
                                <div class="image-frame">
                                    <img
                                        width="100%"
                                        class="lazyload"
                                        alt=""
                                        data-expand="-20"
                                        data-src=""
                                        data-master-src=""
                                        data-master-width=""
                                        data-master-height=""
                                        data-aspectratio=""
                                        data-sizes="auto"
                                    >
                                </div>
                                <div class="item-details">
                                    <h6 class="collections"></h6>
                                    <h4 class="item-title">
                                        <a href=""></a>
                                    </h4>
<!--                                    <input type="hidden" name="product_id[]" value="">-->
<!--                                    <input type="hidden" name="variant_id[]" value="">-->
<!--                                    <input type="hidden" name="quantity[]" value="">-->
                                </div>
                            </div>
                        </div>
                        <div class="quantity">
                            <div class="quantity-block">
                                <div class="v4-quantity-selector ">
                                    <div class="qty"></div>
                                </div>
                            </div>
                        </div>
                        <div class="total">
                            <div class="pricing-block" data-basis-price="" data-comparison-basis-price="">
                                <span class="item-total2" data-total-price=""
                                      data-original-price=""></span>
                            </div>
                        </div>
                    </div>
                </div>`;
    }

    getTotalBundlesPrice(totalBundlesPrice, arrTotalBundlePrice) {
        for (const totalPrice of totalBundlesPrice) {
            const bundleClass = totalPrice.getAttribute("data-bundle-class-id");
            if (bundleClass !== null) {
                const bundleCompareAtPrice = arrTotalBundlePrice[bundleClass].compare_at_price;
                const bundleTotalPrice = arrTotalBundlePrice[bundleClass].bundle_price;
                if (arrTotalBundlePrice[bundleClass].bundle_price !== arrTotalBundlePrice[bundleClass].compare_at_price) {
                    if(bundleCompareAtPrice > bundleTotalPrice)
                        $(totalPrice).find('.compare-at_price_bundle').text(formatMoney(bundleCompareAtPrice, window.moneyFormat));
                }
                $(totalPrice).find('.bundle-price').text(formatMoney(bundleTotalPrice, window.moneyFormat));
            }
        }
    }

    buildItemData() {
        const { lineItems } = this, updates = {};
        for (const key in lineItems)
            updates[key] = lineItems[key].quantity();
        return { updates };
    }

    update() {
        const formData = this.buildItemData();
        this.form.addClass(UPDATING_CLASS);
        const counter = ++this.updateCounter;
        this.cart.update(formData).then(() => this.endUpdate(counter));
    }

    endUpdate(counter) {
        const { form, updateCounter } = this;
        if (counter !== updateCounter)
            return;

        form.removeClass(UPDATING_CLASS);
        for (const lineItem of Object.values(this.lineItems))
            lineItem.clearUpdateMark();
    }

    cancelUpdate() {
        if (this.updateTimerId !== null) {
            clearTimeout(this.updateTimerId);
            this.updateTimerId = null;
        }
    }


    scheduleUpdate() {
        this.cancelUpdate();
        this.updateTimerId = setTimeout(this.update, CHANGE_AGGREGATION_TIME_MSEC);
    }

    handleQuantityChange(e, newQuantity) {
        e.target.markForUpdate();
        this.scheduleUpdate();
    }

    handleBundleQuantityChange(e, newQuantity) {
        e.target.row.addClass(UPDATING_CLASS);
        this.scheduleUpdate();
    }

    handleRemoveBundle(e) {
        e.preventDefault();
        const bundleClass = e.target.getAttribute('data-bundle-class-id');
        const bundleWrapper = $('.bundle-line-item-wrapper[data-bundle-id="' + bundleClass + '"]');
        const bundleLineItems = bundleWrapper.find('.line-item');
        const data = { updates: {} }
        for (let i = 0; i < bundleLineItems.length; i++) {
            const key = bundleLineItems[i].getAttribute('data-item-key');
            data.updates[key] = 0;
        }
        this.api.cartUpdate(data).then(() => window.location.reload());
    }

    handleCartChange(e, cartData) {
        /* Match the new line items to the ones we know about. */
        const { lineItems } = this, newData = {}, newKeys = [];
        let collectBundlePrice = [];
        let bundleCompareAtPrice = 0;
        let bundlePrice = 0;
        let whichBundle = '';
        let countQuantity = 0;
        for (const itemData of cartData.items) {
            const { key, quantity, final_line_price, title } = itemData;
            const lineItem = this.form.find(`[data-item-key='${key}']`);
            const { _bundle, _bundle_discount, _bundle_class, _free_bundle_component } = itemData.properties;
            countQuantity += quantity;
            if (_bundle) {
                const bundleItemCompareAtPrice = lineItem.find('.pricing-block').attr('data-comparison-basis-price');
                const bundleItemOriginalPrice = bundleItemCompareAtPrice !== '' ? bundleItemCompareAtPrice : original_price;
                if (whichBundle === '' || _bundle === whichBundle) {
                    if (!_free_bundle_component) {
                        bundleCompareAtPrice += parseFloat(bundleItemOriginalPrice) * quantity;
                    } else {
                        bundleCompareAtPrice += 0;
                    }

                    bundlePrice += parseFloat(final_line_price);
                } else {
                    bundleCompareAtPrice = 0;
                    bundlePrice = 0;
                    if (!_free_bundle_component) {
                        bundleCompareAtPrice += parseFloat(bundleItemOriginalPrice) * quantity;
                    } else {
                        bundleCompareAtPrice += 0;
                    }
                    bundlePrice += parseFloat(final_line_price);
                }
                const bundleClass = _bundle_class;
                collectBundlePrice[bundleClass] = {
                    'compare_at_price': bundleCompareAtPrice,
                    "bundle_price": bundlePrice
                };
                whichBundle = _bundle;
            }
            let finalComparisonPrice = "";
            if (_bundle) {
                const ComparisonPrice = lineItem.find('.pricing-block').attr('data-comparison-basis-price');
                finalComparisonPrice = ComparisonPrice * quantity;
                lineItem.find('.line-item-quantity').text(quantity);
            } else {
                const ComparisonPrice = lineItem.find('.pricing-block').attr('data-comparison-basis-price');
                finalComparisonPrice = ComparisonPrice * quantity;
            }

            const finalLinePrice = final_line_price == 0 ? "<span>FREE</span>" : formatMoney(final_line_price, window.moneyFormat);
            const baseBundleQty = lineItem.find('.item-total2').attr('data-bundle-base-qty');
            lineItem.find('.item-comparison-total2').text(formatMoney(finalComparisonPrice, window.moneyFormat));
            lineItem.find('.item-total2').html(finalLinePrice);

            newData[key] = itemData;
            if (!(key in lineItems))
                newKeys.push(key);
        }
        
        // if ($('.v5-cart-item-count')) {
        //     if(countQuantity === 0) {
        //         $('.js_cart_total_items').text(countQuantity);
        //     } else if(countQuantity === 1) {
        //         $('.js_cart_total_items').html(`${countQuantity} <span>item</span>`);
        //     } else if(countQuantity > 1) {
        //         $('.js_cart_total_items').html(`${countQuantity}  <span>items</span>`);
        //     }
        // }
        // $('.js_cart_total_items').html();
        console.log('new cart data:', newData);
        /* If items have been added, reload. */
        if (newKeys.length !== 0)
            window.location.reload();

        /* Update all existing line items (some of which may have been deleted). */
        for (const key in lineItems)
            lineItems[key].update(newData[key] || null);
        /* Update the cart total. */
        this.form.find('.cart-subtotal .amount')
            .text(formatMoney(cartData.total_price).replace('$', currencySymbol));

        $('.js_cart_subtotal_amount').text(formatMoney(cartData.total_price).replace('$', currencySymbol));

        const totalBundlesPrice = $('.bundle-price-total-wrapper');
        this.getTotalBundlesPrice(totalBundlesPrice, collectBundlePrice);
    }
}
